import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

const ModalCrearCliente = ({ isOpen, toggle, onSave }) => {
    const [activeTab, setActiveTab] = useState('1');
    const [formData, setFormData] = useState({
        CLIPRO: '',
        TPERSO: '',
        RAZSOC: '',
        APENOM: '',
        APEPAT: '',
        APEMAT: '',
        NOMNOM: '',
        COPAIS: '',
        CODCIU: '',
        CIUDAD: '',
        CODCOM: '',
        COMUNA: '',
        DIRECC: '',
        ELGIRO: '',
        CEMAIL: '',
        CONTAC: '',
        NFONO1: '',
        NFONO2: '',
        NFONO3: '',
        ZIPCOD: '',
        ELSEXO: '',
        SINNAC: false,
        FECNAC: '',
        TIPPRO: '',
        NOMPAG: '',
        TIPPAG: '',
        FORPAG: '',
        NROCTA: '',
        BANCTA: '',
        SUCCTA: '',
        CODSUC: '',
        NOMRET: '',
        RUTRET: '',
        TIPCLI: '',
        SININT: false,
        FLUPRO: '',
        FLUCLI: '',
        PAGCON: '',
        PAGDIA: '',
        PAGFON: '',
        PAGMAI: '',
        AUTDVE: false,
        USUDVE: '',
        FECADV: '',
        BLOLCH: false,
        USUBLH: '',
        FECBLH: '',
        CALLES: '',
        NROCAS: '',
        NRODEP: '',
        NROBLO: '',
        SECPOB: '',
        PORDES: '',
        PORSER: '',
        PORREN: '',
        PORRE1: '',
        PORRE2: '',
        SINODC: false,
        LISPRE: '',
        SINEMAIL: false,
        SINFECHA: false,
        CUPO_CREDITO: '',
        SALDO_CREDITO: '',
        UTILIZADO_CREDITO: '',
        ESTADO_CREDITO: '',
        IDSUCURSAL: '',
        RECARGO_FLAG: false,
        RECARGO_MONTO: '',
        FLAG_SIGA: '',
        FLAG_EXT: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
        setFormData({
            CLIPRO: '',
            TPERSO: '',
            RAZSOC: '',
            APENOM: '',
            APEPAT: '',
            APEMAT: '',
            NOMNOM: '',
            COPAIS: '',
            CODCIU: '',
            CIUDAD: '',
            CODCOM: '',
            COMUNA: '',
            DIRECC: '',
            ELGIRO: '',
            CEMAIL: '',
            CONTAC: '',
            NFONO1: '',
            NFONO2: '',
            NFONO3: '',
            ZIPCOD: '',
            ELSEXO: '',
            SINNAC: false,
            FECNAC: '',
            TIPPRO: '',
            NOMPAG: '',
            TIPPAG: '',
            FORPAG: '',
            NROCTA: '',
            BANCTA: '',
            SUCCTA: '',
            CODSUC: '',
            NOMRET: '',
            RUTRET: '',
            TIPCLI: '',
            SININT: false,
            FLUPRO: '',
            FLUCLI: '',
            PAGCON: '',
            PAGDIA: '',
            PAGFON: '',
            PAGMAI: '',
            AUTDVE: false,
            USUDVE: '',
            FECADV: '',
            BLOLCH: false,
            USUBLH: '',
            FECBLH: '',
            CALLES: '',
            NROCAS: '',
            NRODEP: '',
            NROBLO: '',
            SECPOB: '',
            PORDES: '',
            PORSER: '',
            PORREN: '',
            PORRE1: '',
            PORRE2: '',
            SINODC: false,
            LISPRE: '',
            SINEMAIL: false,
            SINFECHA: false,
            CUPO_CREDITO: '',
            SALDO_CREDITO: '',
            UTILIZADO_CREDITO: '',
            ESTADO_CREDITO: '',
            IDSUCURSAL: '',
            RECARGO_FLAG: false,
            RECARGO_MONTO: '',
            FLAG_SIGA: '',
            FLAG_EXT: ''
        });
        toggle();
    };

    const handleCancel = () => {
        setFormData({
            CLIPRO: '',
            TPERSO: '',
            RAZSOC: '',
            APENOM: '',
            APEPAT: '',
            APEMAT: '',
            NOMNOM: '',
            COPAIS: '',
            CODCIU: '',
            CIUDAD: '',
            CODCOM: '',
            COMUNA: '',
            DIRECC: '',
            ELGIRO: '',
            CEMAIL: '',
            CONTAC: '',
            NFONO1: '',
            NFONO2: '',
            NFONO3: '',
            ZIPCOD: '',
            ELSEXO: '',
            SINNAC: false,
            FECNAC: '',
            TIPPRO: '',
            NOMPAG: '',
            TIPPAG: '',
            FORPAG: '',
            NROCTA: '',
            BANCTA: '',
            SUCCTA: '',
            CODSUC: '',
            NOMRET: '',
            RUTRET: '',
            TIPCLI: '',
            SININT: false,
            FLUPRO: '',
            FLUCLI: '',
            PAGCON: '',
            PAGDIA: '',
            PAGFON: '',
            PAGMAI: '',
            AUTDVE: false,
            USUDVE: '',
            FECADV: '',
            BLOLCH: false,
            USUBLH: '',
            FECBLH: '',
            CALLES: '',
            NROCAS: '',
            NRODEP: '',
            NROBLO: '',
            SECPOB: '',
            PORDES: '',
            PORSER: '',
            PORREN: '',
            PORRE1: '',
            PORRE2: '',
            SINODC: false,
            LISPRE: '',
            SINEMAIL: false,
            SINFECHA: false,
            CUPO_CREDITO: '',
            SALDO_CREDITO: '',
            UTILIZADO_CREDITO: '',
            ESTADO_CREDITO: '',
            IDSUCURSAL: '',
            RECARGO_FLAG: false,
            RECARGO_MONTO: '',
            FLAG_SIGA: '',
            FLAG_EXT: ''
        });
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                <i className="ri-user-add-line me-2"></i>
                Crear Cliente
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={activeTab === '1' ? 'active' : ''}
                                onClick={() => toggleTab('1')}
                            >
                                Información Básica
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '2' ? 'active' : ''}
                                onClick={() => toggleTab('2')}
                            >
                                Datos Personales
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '3' ? 'active' : ''}
                                onClick={() => toggleTab('3')}
                            >
                                Contacto
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '4' ? 'active' : ''}
                                onClick={() => toggleTab('4')}
                            >
                                Dirección
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '5' ? 'active' : ''}
                                onClick={() => toggleTab('5')}
                            >
                                Negocio
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '6' ? 'active' : ''}
                                onClick={() => toggleTab('6')}
                            >
                                Financiero
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '7' ? 'active' : ''}
                                onClick={() => toggleTab('7')}
                            >
                                Sistema
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <div className="row mt-3">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CLIPRO">RUT *</Label>
                                        <Input
                                            type="text"
                                            id="CLIPRO"
                                            name="CLIPRO"
                                            value={formData.CLIPRO}
                                            onChange={handleInputChange}
                                            placeholder="Ej: 78.123.456-7"
                                            required
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="TPERSO">Tipo de Persona</Label>
                                        <Input
                                            type="select"
                                            id="TPERSO"
                                            name="TPERSO"
                                            value={formData.TPERSO}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Seleccionar...</option>
                                            <option value="P">Persona Natural</option>
                                            <option value="E">Persona Jurídica</option>
                                        </Input>
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="RAZSOC">Razón Social</Label>
                                        <Input
                                            type="text"
                                            id="RAZSOC"
                                            name="RAZSOC"
                                            value={formData.RAZSOC}
                                            onChange={handleInputChange}
                                            placeholder="Nombre de la empresa"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="APENOM">Nombre Completo</Label>
                                        <Input
                                            type="text"
                                            id="APENOM"
                                            name="APENOM"
                                            value={formData.APENOM}
                                            onChange={handleInputChange}
                                            placeholder="Nombre y apellido"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </TabPane>

                        <TabPane tabId="2">
                            <div className="row mt-3">
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="APEPAT">Apellido Paterno</Label>
                                        <Input
                                            type="text"
                                            id="APEPAT"
                                            name="APEPAT"
                                            value={formData.APEPAT}
                                            onChange={handleInputChange}
                                            placeholder="Apellido paterno"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="APEMAT">Apellido Materno</Label>
                                        <Input
                                            type="text"
                                            id="APEMAT"
                                            name="APEMAT"
                                            value={formData.APEMAT}
                                            onChange={handleInputChange}
                                            placeholder="Apellido materno"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="NOMNOM">Nombres</Label>
                                        <Input
                                            type="text"
                                            id="NOMNOM"
                                            name="NOMNOM"
                                            value={formData.NOMNOM}
                                            onChange={handleInputChange}
                                            placeholder="Nombres"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="ELSEXO">Sexo</Label>
                                        <Input
                                            type="select"
                                            id="ELSEXO"
                                            name="ELSEXO"
                                            value={formData.ELSEXO}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Seleccionar...</option>
                                            <option value="M">Masculino</option>
                                            <option value="F">Femenino</option>
                                        </Input>
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="SINNAC"
                                                name="SINNAC"
                                                checked={formData.SINNAC}
                                                onChange={(e) => setFormData(prev => ({ ...prev, SINNAC: e.target.checked }))}
                                            />
                                            Sin Fecha de Nacimiento
                                        </Label>
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="FECNAC">Fecha de Nacimiento</Label>
                                        <Input
                                            type="date"
                                            id="FECNAC"
                                            name="FECNAC"
                                            value={formData.FECNAC}
                                            onChange={handleInputChange}
                                            disabled={formData.SINNAC}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </TabPane>

                        <TabPane tabId="3">
                            <div className="row mt-3">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CEMAIL">Correo Electrónico</Label>
                                        <Input
                                            type="email"
                                            id="CEMAIL"
                                            name="CEMAIL"
                                            value={formData.CEMAIL}
                                            onChange={handleInputChange}
                                            placeholder="cliente@email.com"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CONTAC">Persona de Contacto</Label>
                                        <Input
                                            type="text"
                                            id="CONTAC"
                                            name="CONTAC"
                                            value={formData.CONTAC}
                                            onChange={handleInputChange}
                                            placeholder="Nombre del contacto"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="NFONO1">Teléfono 1</Label>
                                        <Input
                                            type="tel"
                                            id="NFONO1"
                                            name="NFONO1"
                                            value={formData.NFONO1}
                                            onChange={handleInputChange}
                                            placeholder="+56 9 1234 5678"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="NFONO2">Teléfono 2</Label>
                                        <Input
                                            type="tel"
                                            id="NFONO2"
                                            name="NFONO2"
                                            value={formData.NFONO2}
                                            onChange={handleInputChange}
                                            placeholder="+56 9 1234 5678"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="NFONO3">Teléfono 3</Label>
                                        <Input
                                            type="tel"
                                            id="NFONO3"
                                            name="NFONO3"
                                            value={formData.NFONO3}
                                            onChange={handleInputChange}
                                            placeholder="+56 9 1234 5678"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </TabPane>

                        <TabPane tabId="4">
                            <div className="row mt-3">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="COPAIS">Código País</Label>
                                        <Input
                                            type="text"
                                            id="COPAIS"
                                            name="COPAIS"
                                            value={formData.COPAIS}
                                            onChange={handleInputChange}
                                            placeholder="CL"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CODCIU">Código Ciudad</Label>
                                        <Input
                                            type="text"
                                            id="CODCIU"
                                            name="CODCIU"
                                            value={formData.CODCIU}
                                            onChange={handleInputChange}
                                            placeholder="Código de ciudad"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CIUDAD">Ciudad</Label>
                                        <Input
                                            type="text"
                                            id="CIUDAD"
                                            name="CIUDAD"
                                            value={formData.CIUDAD}
                                            onChange={handleInputChange}
                                            placeholder="Nombre de la ciudad"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CODCOM">Código Comuna</Label>
                                        <Input
                                            type="text"
                                            id="CODCOM"
                                            name="CODCOM"
                                            value={formData.CODCOM}
                                            onChange={handleInputChange}
                                            placeholder="Código de comuna"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="COMUNA">Comuna</Label>
                                        <Input
                                            type="text"
                                            id="COMUNA"
                                            name="COMUNA"
                                            value={formData.COMUNA}
                                            onChange={handleInputChange}
                                            placeholder="Nombre de la comuna"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="ZIPCOD">Código Postal</Label>
                                        <Input
                                            type="text"
                                            id="ZIPCOD"
                                            name="ZIPCOD"
                                            value={formData.ZIPCOD}
                                            onChange={handleInputChange}
                                            placeholder="Código postal"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <FormGroup>
                                        <Label for="DIRECC">Dirección Completa</Label>
                                        <Input
                                            type="text"
                                            id="DIRECC"
                                            name="DIRECC"
                                            value={formData.DIRECC}
                                            onChange={handleInputChange}
                                            placeholder="Dirección completa"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-3">
                                    <FormGroup>
                                        <Label for="CALLES">Calle</Label>
                                        <Input
                                            type="text"
                                            id="CALLES"
                                            name="CALLES"
                                            value={formData.CALLES}
                                            onChange={handleInputChange}
                                            placeholder="Nombre de la calle"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-3">
                                    <FormGroup>
                                        <Label for="NROCAS">N° Casa</Label>
                                        <Input
                                            type="text"
                                            id="NROCAS"
                                            name="NROCAS"
                                            value={formData.NROCAS}
                                            onChange={handleInputChange}
                                            placeholder="Número"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-3">
                                    <FormGroup>
                                        <Label for="NRODEP">N° Depto</Label>
                                        <Input
                                            type="text"
                                            id="NRODEP"
                                            name="NRODEP"
                                            value={formData.NRODEP}
                                            onChange={handleInputChange}
                                            placeholder="Depto"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-3">
                                    <FormGroup>
                                        <Label for="NROBLO">N° Block</Label>
                                        <Input
                                            type="text"
                                            id="NROBLO"
                                            name="NROBLO"
                                            value={formData.NROBLO}
                                            onChange={handleInputChange}
                                            placeholder="Block"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <FormGroup>
                                        <Label for="SECPOB">Sector/Población</Label>
                                        <Input
                                            type="text"
                                            id="SECPOB"
                                            name="SECPOB"
                                            value={formData.SECPOB}
                                            onChange={handleInputChange}
                                            placeholder="Sector o población"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </TabPane>

                        <TabPane tabId="5">
                            <div className="row mt-3">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="ELGIRO">Giro</Label>
                                        <Input
                                            type="text"
                                            id="ELGIRO"
                                            name="ELGIRO"
                                            value={formData.ELGIRO}
                                            onChange={handleInputChange}
                                            placeholder="Giro del negocio"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="TIPPRO">Tipo de Proveedor</Label>
                                        <Input
                                            type="text"
                                            id="TIPPRO"
                                            name="TIPPRO"
                                            value={formData.TIPPRO}
                                            onChange={handleInputChange}
                                            placeholder="Tipo de proveedor"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="NOMPAG">Nombre para Cheques</Label>
                                        <Input
                                            type="text"
                                            id="NOMPAG"
                                            name="NOMPAG"
                                            value={formData.NOMPAG}
                                            onChange={handleInputChange}
                                            placeholder="Nombre para giros"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="TIPCLI">Tipo de Cliente</Label>
                                        <Input
                                            type="text"
                                            id="TIPCLI"
                                            name="TIPCLI"
                                            value={formData.TIPCLI}
                                            onChange={handleInputChange}
                                            placeholder="Tipo de cliente"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="FLUPRO">Flujo Proveedor</Label>
                                        <Input
                                            type="text"
                                            id="FLUPRO"
                                            name="FLUPRO"
                                            value={formData.FLUPRO}
                                            onChange={handleInputChange}
                                            placeholder="Código de flujo proveedor"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="FLUCLI">Flujo Cliente</Label>
                                        <Input
                                            type="text"
                                            id="FLUCLI"
                                            name="FLUCLI"
                                            value={formData.FLUCLI}
                                            onChange={handleInputChange}
                                            placeholder="Código de flujo cliente"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </TabPane>

                        <TabPane tabId="6">
                            <div className="row mt-3">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="TIPPAG">Tipo de Pago</Label>
                                        <Input
                                            type="text"
                                            id="TIPPAG"
                                            name="TIPPAG"
                                            value={formData.TIPPAG}
                                            onChange={handleInputChange}
                                            placeholder="Tipo de pago"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="FORPAG">Forma de Pago</Label>
                                        <Input
                                            type="text"
                                            id="FORPAG"
                                            name="FORPAG"
                                            value={formData.FORPAG}
                                            onChange={handleInputChange}
                                            placeholder="Forma de pago"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="NROCTA">Número de Cuenta</Label>
                                        <Input
                                            type="text"
                                            id="NROCTA"
                                            name="NROCTA"
                                            value={formData.NROCTA}
                                            onChange={handleInputChange}
                                            placeholder="Número de cuenta corriente"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="BANCTA">Banco</Label>
                                        <Input
                                            type="text"
                                            id="BANCTA"
                                            name="BANCTA"
                                            value={formData.BANCTA}
                                            onChange={handleInputChange}
                                            placeholder="Código del banco"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="SUCCTA">Sucursal</Label>
                                        <Input
                                            type="text"
                                            id="SUCCTA"
                                            name="SUCCTA"
                                            value={formData.SUCCTA}
                                            onChange={handleInputChange}
                                            placeholder="Sucursal de la cuenta"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CODSUC">Código Sucursal</Label>
                                        <Input
                                            type="text"
                                            id="CODSUC"
                                            name="CODSUC"
                                            value={formData.CODSUC}
                                            onChange={handleInputChange}
                                            placeholder="Código de sucursal"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CUPO_CREDITO">Cupo de Crédito</Label>
                                        <Input
                                            type="number"
                                            id="CUPO_CREDITO"
                                            name="CUPO_CREDITO"
                                            value={formData.CUPO_CREDITO}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="SALDO_CREDITO">Saldo de Crédito</Label>
                                        <Input
                                            type="number"
                                            id="SALDO_CREDITO"
                                            name="SALDO_CREDITO"
                                            value={formData.SALDO_CREDITO}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="UTILIZADO_CREDITO">Crédito Utilizado</Label>
                                        <Input
                                            type="number"
                                            id="UTILIZADO_CREDITO"
                                            name="UTILIZADO_CREDITO"
                                            value={formData.UTILIZADO_CREDITO}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="ESTADO_CREDITO">Estado Crédito</Label>
                                        <Input
                                            type="select"
                                            id="ESTADO_CREDITO"
                                            name="ESTADO_CREDITO"
                                            value={formData.ESTADO_CREDITO}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Seleccionar...</option>
                                            <option value="1">Abierta</option>
                                            <option value="0">Sin Línea</option>
                                        </Input>
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="SININT"
                                                name="SININT"
                                                checked={formData.SININT}
                                                onChange={(e) => setFormData(prev => ({ ...prev, SININT: e.target.checked }))}
                                            />
                                            Sin Cálculo de Intereses
                                        </Label>
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="RECARGO_FLAG"
                                                name="RECARGO_FLAG"
                                                checked={formData.RECARGO_FLAG}
                                                onChange={(e) => setFormData(prev => ({ ...prev, RECARGO_FLAG: e.target.checked }))}
                                            />
                                            Indicador de Recargo
                                        </Label>
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="RECARGO_MONTO">Monto de Recargo</Label>
                                        <Input
                                            type="number"
                                            id="RECARGO_MONTO"
                                            name="RECARGO_MONTO"
                                            value={formData.RECARGO_MONTO}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="LISPRE">Lista de Precios</Label>
                                        <Input
                                            type="number"
                                            id="LISPRE"
                                            name="LISPRE"
                                            value={formData.LISPRE}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-3">
                                    <FormGroup>
                                        <Label for="PORDES">% Desc. Productos</Label>
                                        <Input
                                            type="number"
                                            step="0.01"
                                            id="PORDES"
                                            name="PORDES"
                                            value={formData.PORDES}
                                            onChange={handleInputChange}
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-3">
                                    <FormGroup>
                                        <Label for="PORSER">% Desc. Servicios</Label>
                                        <Input
                                            type="number"
                                            step="0.01"
                                            id="PORSER"
                                            name="PORSER"
                                            value={formData.PORSER}
                                            onChange={handleInputChange}
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-3">
                                    <FormGroup>
                                        <Label for="PORREN">% Desc. Rentacar</Label>
                                        <Input
                                            type="number"
                                            step="0.01"
                                            id="PORREN"
                                            name="PORREN"
                                            value={formData.PORREN}
                                            onChange={handleInputChange}
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-3">
                                    <FormGroup>
                                        <Label for="PORRE1">% Rec. Productos</Label>
                                        <Input
                                            type="number"
                                            step="0.01"
                                            id="PORRE1"
                                            name="PORRE1"
                                            value={formData.PORRE1}
                                            onChange={handleInputChange}
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="PORRE2">% Rec. Servicios</Label>
                                        <Input
                                            type="number"
                                            step="0.01"
                                            id="PORRE2"
                                            name="PORRE2"
                                            value={formData.PORRE2}
                                            onChange={handleInputChange}
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="SINODC"
                                                name="SINODC"
                                                checked={formData.SINODC}
                                                onChange={(e) => setFormData(prev => ({ ...prev, SINODC: e.target.checked }))}
                                            />
                                            Compras sin Orden de Compra
                                        </Label>
                                    </FormGroup>
                                </div>
                            </div>
                        </TabPane>

                        <TabPane tabId="7">
                            <div className="row mt-3">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="NOMRET">Nombre Retira Documentos</Label>
                                        <Input
                                            type="text"
                                            id="NOMRET"
                                            name="NOMRET"
                                            value={formData.NOMRET}
                                            onChange={handleInputChange}
                                            placeholder="Nombre de quien retira"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="RUTRET">RUT Retira Documentos</Label>
                                        <Input
                                            type="text"
                                            id="RUTRET"
                                            name="RUTRET"
                                            value={formData.RUTRET}
                                            onChange={handleInputChange}
                                            placeholder="RUT de quien retira"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="PAGCON">Contacto de Cobranza</Label>
                                        <Input
                                            type="text"
                                            id="PAGCON"
                                            name="PAGCON"
                                            value={formData.PAGCON}
                                            onChange={handleInputChange}
                                            placeholder="Nombre del contacto"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="PAGDIA">Día Contacto Cobranza</Label>
                                        <Input
                                            type="text"
                                            id="PAGDIA"
                                            name="PAGDIA"
                                            value={formData.PAGDIA}
                                            onChange={handleInputChange}
                                            placeholder="Día de contacto"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="PAGFON">Teléfono Cobranza</Label>
                                        <Input
                                            type="tel"
                                            id="PAGFON"
                                            name="PAGFON"
                                            value={formData.PAGFON}
                                            onChange={handleInputChange}
                                            placeholder="Teléfono de cobranza"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="PAGMAI">Email Cobranza</Label>
                                        <Input
                                            type="email"
                                            id="PAGMAI"
                                            name="PAGMAI"
                                            value={formData.PAGMAI}
                                            onChange={handleInputChange}
                                            placeholder="email@cobranza.com"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="AUTDVE"
                                                name="AUTDVE"
                                                checked={formData.AUTDVE}
                                                onChange={(e) => setFormData(prev => ({ ...prev, AUTDVE: e.target.checked }))}
                                            />
                                            Autorización Venta con DV
                                        </Label>
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="USUDVE">Usuario Autoriza DV</Label>
                                        <Input
                                            type="text"
                                            id="USUDVE"
                                            name="USUDVE"
                                            value={formData.USUDVE}
                                            onChange={handleInputChange}
                                            placeholder="Usuario que autoriza"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="FECADV">Fecha Autorización DV</Label>
                                        <Input
                                            type="datetime-local"
                                            id="FECADV"
                                            name="FECADV"
                                            value={formData.FECADV}
                                            onChange={handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="BLOLCH">Bloqueo Cheques</Label>
                                        <Input
                                            type="number"
                                            id="BLOLCH"
                                            name="BLOLCH"
                                            value={formData.BLOLCH}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="USUBLH">Usuario Bloqueó</Label>
                                        <Input
                                            type="text"
                                            id="USUBLH"
                                            name="USUBLH"
                                            value={formData.USUBLH}
                                            onChange={handleInputChange}
                                            placeholder="Usuario que bloqueó"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="FECBLH">Fecha Bloqueo</Label>
                                        <Input
                                            type="datetime-local"
                                            id="FECBLH"
                                            name="FECBLH"
                                            value={formData.FECBLH}
                                            onChange={handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-4">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="SINEMAIL"
                                                name="SINEMAIL"
                                                checked={formData.SINEMAIL}
                                                onChange={(e) => setFormData(prev => ({ ...prev, SINEMAIL: e.target.checked }))}
                                            />
                                            Sin Email
                                        </Label>
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="SINFECHA"
                                                name="SINFECHA"
                                                checked={formData.SINFECHA}
                                                onChange={(e) => setFormData(prev => ({ ...prev, SINFECHA: e.target.checked }))}
                                            />
                                            Sin Fecha Nacimiento
                                        </Label>
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <FormGroup>
                                        <Label for="IDSUCURSAL">ID Sucursal</Label>
                                        <Input
                                            type="number"
                                            id="IDSUCURSAL"
                                            name="IDSUCURSAL"
                                            value={formData.IDSUCURSAL}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="FLAG_SIGA">Flag SIGA</Label>
                                        <Input
                                            type="number"
                                            id="FLAG_SIGA"
                                            name="FLAG_SIGA"
                                            value={formData.FLAG_SIGA}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="FLAG_EXT">Flag Externo</Label>
                                        <Input
                                            type="number"
                                            id="FLAG_EXT"
                                            name="FLAG_EXT"
                                            value={formData.FLAG_EXT}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </TabPane>
                    </TabContent>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-light" onClick={handleCancel}>
                        Cancelar
                    </button>
                    <button type="submit" className="btn btn-success">
                        <i className="ri-save-line me-1"></i>
                        Crear
                    </button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default ModalCrearCliente;